import {
	INBOX_GENERIC_ACTIVITY_LIST_SORT,
	INBOX_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE,
} from 'src/stores/inbox/localStorageKeys';
import { TSMap } from 'typescript-map';

import { Activity } from 'src/models/activity';
import { DateRangeSelection } from 'src/models/common';
import { FilterBoxes, FilterUsers } from 'src/models/filter';
import {
	ActivityListTypeEnum,
	GenericActivityListPagination,
	GenericActivityListSort,
} from 'src/models/genericActivityList';
import { SerializedQuery } from 'src/models/query';

interface InboxStateInterface {
	activeQueryIdentifierByListType: TSMap<ActivityListTypeEnum, string>;
	dateFilter: DateRangeSelection | string;
	desktopAccessUsers: Array<FilterUsers>;
	desktopAccessUsersFetching: boolean;
	filterBoxes: Array<FilterBoxes>;
	filterUsers: Array<FilterUsers>;
	filteredBoxIds: Array<string>;
	filteredUsers: Array<FilterUsers>;
	inboxListOpen: Array<Activity>;
	inboxListOpenSliced: Map<number, Array<Activity>>;
	inboxListOpenTotalCount: number;
	listViewModeLarge: boolean;
	pagination: TSMap<ActivityListTypeEnum, GenericActivityListPagination>;
	queryStoreSubscriptions: Array<SerializedQuery>;
	sort: TSMap<ActivityListTypeEnum, GenericActivityListSort>;
	viewedUserId: null | number;
}

function state(): InboxStateInterface {
	return {
		activeQueryIdentifierByListType: new TSMap<ActivityListTypeEnum, string>(),
		dateFilter: new Date().toISOString().split('T')[0],
		desktopAccessUsers: [],
		desktopAccessUsersFetching: false,
		filterBoxes: [],
		filterUsers: [],
		filteredBoxIds: [],
		filteredUsers: [],
		inboxListOpen: [],
		inboxListOpenSliced: new Map<number, Array<Activity>>(),
		inboxListOpenTotalCount: 0,
		listViewModeLarge:
			localStorage.getItem(INBOX_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) !== null
				? /true/i.test(
						localStorage.getItem(INBOX_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) as 'false' | 'true'
					)
				: true,
		pagination: new TSMap<ActivityListTypeEnum, GenericActivityListPagination>([
			[
				ActivityListTypeEnum.OPEN,
				{
					page: 1,
					rowsPerPage: 100,
				},
			],
		]),
		queryStoreSubscriptions: [],
		sort:
			localStorage.getItem(INBOX_GENERIC_ACTIVITY_LIST_SORT) !== null
				? new TSMap<ActivityListTypeEnum, GenericActivityListSort>().fromJSON(
						JSON.parse(localStorage.getItem(INBOX_GENERIC_ACTIVITY_LIST_SORT) as string)
					)
				: new TSMap<ActivityListTypeEnum, GenericActivityListSort>([
						[
							ActivityListTypeEnum.ALL,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.MINE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.OPEN,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
					]),
		viewedUserId: null,
	};
}

export default state;
